module.exports = __webpack_public_path__ + "img/img-3.28a5e98b.png";